import React from "react";
import { toast } from "react-toastify";
import { ImageUpload, EditableField } from "../../components";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";

import "react-tabs/style/react-tabs.css";

import PropTypes from "prop-types";
import moment from "moment";
import selectors from "./selectors";
import actions from "../../actions";
import { connect } from "react-redux";
import { set, isEmpty, merge } from "lodash";
import { withRouter } from "react-router-dom";
import { AWS_STATIC_ENDPOINT } from "../../../../../common/constants";

class CustomerDetail extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      origin_customer: {},
      customer: {},
      top_rated_posts: [],
      recent_posts: [],
      pending_posts: [],
      upcoming_trips: [],
      past_trips: [],
      query: {},
      loading: false,
      new_password: "",
      confirm_password: "",
    };
    this.onAvatarChange = this.onAvatarChange.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleClick = this.handleClick.bind(this);
  }

  componentDidMount() {
    const {
      getCustomerDetail,
      getTopRatedPosts,
      getRecentPosts,
      getPendingPosts,
      getTripPlans,
      match: {
        params: { id },
      },
    } = this.props;
    this.setState({
      loading: true,
    });

    getCustomerDetail(id)
      .then(({ result: { data } }) => {
        if (data.result === "success") {
          this.setState({
            customer: data.data,
            origin_customer: data.data,
          });
        } else {
          toast.error("Failed to get customer info");
        }
        this.setState({
          loading: false,
        });
      })
      .catch(() => {
        toast.error("Internal Server Error");
        this.setState({
          loading: false,
        });
      });

    getTopRatedPosts({ customer_id: id, limit: 4 })
      .then(({ result: { data } }) => {
        if (data.result === "success") {
          this.setState({
            top_rated_posts: data.data,
          });
        }
      })
      .catch(() => {
        toast.error("Internal Server Error");
      });

    getRecentPosts({ customer_id: id, limit: 4 })
      .then(({ result: { data } }) => {
        if (data.result === "success") {
          this.setState({
            recent_posts: data.data,
          });
        }
      })
      .catch(() => {
        toast.error("Internal Server Error");
      });

    getPendingPosts({ customer_id: id, limit: 4 })
      .then(({ result: { data } }) => {
        if (data.result === "success") {
          this.setState({
            pending_posts: data.data,
          });
        }
      })
      .catch(() => {
        toast.error("Internal Server Error");
      });

    getTripPlans({ limit: 4, customer_id: id, type: "new" })
      .then(({ result: { data } }) => {
        if (data.result === "success") {
          this.setState({
            upcoming_trips: data.data,
          });
        }
      })
      .catch(() => {
        toast.error("Internal Server Error");
      });

    getTripPlans({ limit: 4, customer_id: id, type: "past" })
      .then(({ result: { data } }) => {
        if (data.result === "success") {
          this.setState({
            past_trips: data.data,
          });
        }
      })
      .catch(() => {
        toast.error("Internal Server Error");
      });
  }

  onAvatarChange(e) {
    let { query, customer } = this.state;
    const avatar = e.target.files[0];
    merge(query, {
      file: avatar,
    });

    this.setState({
      query: query,
    });

    let reader = new FileReader();
    reader.onloadend = (el) => {
      customer.avatar = el.target.result;
      this.setState({
        customer: customer,
      });
    };

    reader.readAsDataURL(avatar);
  }

  validatePassword() {
    const { new_password, confirm_password } = this.state;

    if (new_password.length === 0) {
      toast.warning("New Password is empty");
      return false;
    }

    if (confirm_password.length === 0) {
      toast.warning("Confirm Password is empty");
      return false;
    }

    if (new_password !== confirm_password) {
      toast.warning("Password doesn't match");
      return false;
    }

    return true;
  }

  handleInputChange({ target: { id, value } }) {
    if (id === "new_password") {
      this.setState({ [id]: value });
      return;
    }
    if (id === "confirm_password") {
      this.setState({ [id]: value });
      return;
    }
    let { customer, query } = this.state;
    set(customer, id, value);
    set(query, id, value);

    this.setState({ customer, query });
  }

  handleClick(event) {
    const { query, origin_customer, new_password } = this.state;
    const {
      updateCustomer,
      disconnectCustomer,
      resetPassword,
      match: {
        params: { id },
      },
    } = this.props;

    if (event.target.id === "cancel_but") {
      this.setState({
        customer: origin_customer,
        query: {},
      });
    } else if (event.target.id === "save_but") {
      if (isEmpty(query)) {
        toast.error("Update customer data is empty");
        return;
      }

      updateCustomer(id, query)
        .then(({ result: { data } }) => {
          if (data.result === "success") {
            toast.success("Customer was updated successfully.");
          }
        })
        .catch(() => {
          toast.error("Internal Server Error");
        });
    } else if (event.target.id === "disconnect_but") {
      disconnectCustomer(id)
        .then(({ result: { data } }) => {
          toast.success(data.message);
        })
        .catch(({ response: { data } }) => {
          toast.error(data.message);
        });
    } else if (event.target.id === "reset_password_but") {
      if (this.validatePassword()) {
        resetPassword({ customer_id: id, password: new_password })
          .then(({ result: { data } }) => {
            toast.success(data.message);
          })
          .catch(({ response: { data } }) => {
            console.log(data);
            toast.error(data.message);
          });
      }
    }
  }

  renderCustomerInfo() {
    const { customer, query, loading } = this.state;
    if (loading) {
      return null;
    }
    return (
      <div className="card">
        <div className="card-body">
          <div className="row">
            <div className="col-12">
              <ImageUpload
                avatar={customer.avatar}
                name="image"
                onChange={this.onAvatarChange}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-12 user-info-container">
              <label>Username</label>
              <div className="info-item">
                <EditableField>
                  <div>
                    <div className="hide-on-edit static-value">
                      <span className="static-field">{customer.username}</span>
                    </div>
                    <input
                      type="text"
                      className="dark-input sm-input show-on-edit input-field"
                      value={customer.username}
                      placeholder="Username"
                      id="username"
                      onChange={this.handleInputChange}
                    />
                    <div className="action" />
                  </div>
                </EditableField>
              </div>
            </div>
            <div className="col-12 user-info-container">
              <label>Email</label>
              <div className="info-item">
                <EditableField>
                  <div>
                    <div className="hide-on-edit static-value">
                      <span className="static-field">{customer.email}</span>
                    </div>
                    <input
                      type="email"
                      className="dark-input sm-input show-on-edit input-field"
                      value={customer.email}
                      placeholder="Email"
                      id="email"
                      onChange={this.handleInputChange}
                    />
                    <div className="action" />
                  </div>
                </EditableField>
              </div>
            </div>
            <div className="col-12 user-info-container">
              <label>Display Name</label>
              <div className="info-item">
                <EditableField>
                  <div>
                    <div className="hide-on-edit static-value">
                      <span className="static-field">
                        {customer.display_name}
                      </span>
                    </div>
                    <input
                      type="text"
                      className="dark-input sm-input show-on-edit input-field"
                      value={customer.display_name}
                      placeholder="Display Name"
                      id="display_name"
                      onChange={this.handleInputChange}
                    />
                    <div className="action" />
                  </div>
                </EditableField>
              </div>
            </div>
            <div className="col-12 user-info-container">
              <label>Posts Count</label>
              <div className="info-item">
                <div className="info-count">{customer.posts}</div>
              </div>
            </div>
            <div className="col-12 user-info-container">
              <label>Followers Count</label>
              <div className="info-item">
                <div className="info-count">{customer.follower}</div>
              </div>
            </div>
            <div className="col-12 user-info-container">
              <label>Following Count</label>
              <div className="info-item">
                <div className="info-count">{customer.following}</div>
              </div>
            </div>
          </div>
        </div>
        <div className="card-footer">
          <div className="row">
            <div className="col-4 h-left">
              <button
                className="btn btn-primary manage-profile-but"
                id="disconnect_but"
                onClick={this.handleClick}
              >
                {"Disconnect"}
              </button>
            </div>
            {!isEmpty(query) ? (
              <div className="col-8">
                <button
                  className="btn btn-primary manage-profile-but"
                  id="save_but"
                  onClick={this.handleClick}
                >
                  {"Save"}
                </button>
                <button
                  className="btn btn-outline manage-profile-but"
                  id="cancel_but"
                  onClick={this.handleCancel}
                >
                  {"Cancel"}
                </button>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    );
  }

  renderPasswordReset() {
    const { new_password, confirm_password } = this.state;
    return (
      <div className="card">
        <div className="card-body">
          <div className="row">
            <div className="col-12 user-info-container">
              <label>New Password</label>
              <div className="info-item">
                <input
                  type="password"
                  className="dark-input sm-input show-on-edit input-field"
                  value={new_password}
                  placeholder="New Password"
                  id="new_password"
                  onChange={this.handleInputChange}
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12 user-info-container">
              <label>Confirm Password</label>
              <div className="info-item">
                <input
                  type="password"
                  className="dark-input sm-input show-on-edit input-field"
                  value={confirm_password}
                  placeholder="Confirm Password"
                  id="confirm_password"
                  onChange={this.handleInputChange}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="card-footer">
          <div className="row">
            <div className="col-12 h-right">
              <button
                className="btn btn-primary manage-profile-but"
                id="reset_password_but"
                onClick={this.handleClick}
              >
                {"Reset Password"}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderTabBar() {
    return (
      <Tabs>
        <TabList>
          <Tab>{"Posts"}</Tab>
          <Tab>{"Trip Plans"}</Tab>
        </TabList>

        <TabPanel>{this.renderPosts()}</TabPanel>
        <TabPanel>{this.renderTripPlans()}</TabPanel>
      </Tabs>
    );
  }

  renderPostThumbnail(mediaInfo) {
    if (mediaInfo.length > 0) {
      if (mediaInfo[0].media_type === "image")
        return (
          <img
            className="related-post-item-image"
            src={mediaInfo[0].media_file}
            height={200}
          ></img>
        );
      else if (mediaInfo[0].media_type === "video")
        return (
          <img
            className="related-post-item-image"
            src={mediaInfo[0].thumbnail}
            height={200}
          ></img>
        );
    }
    return (
      <img
        className="related-post-item-image"
        src={AWS_STATIC_ENDPOINT + "/images/share_logo"}
        height={200}
      ></img>
    );
  }

  renderRecentPostsRow(posts) {
    return (
      <div className="row">
        {posts.map((item, key) => {
          return (
            <div className="col-12 col-sm-3" key={key}>
              <div className="related-post-item">
                {this.renderPostThumbnail(item.mediaInfo)}
                <div className="related-post-item-description">
                  {item.title}
                </div>
                <div className="related-post-item-value">
                  <div className="related-post-item-price">
                    {item.price
                      ? "Price " + item.price + " " + item.currency
                        ? item.currency.toUpperCase()
                        : ""
                      : null}
                  </div>
                  <div className="related-post-item-time-limit">
                    {moment(item.time_limit).format("YYYY-MM-DD")}
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    );
  }

  renderTopPostsRow(posts) {
    return (
      <div className="row">
        {posts.map((item, key) => {
          return (
            <div className="col-12 col-sm-3" key={key}>
              <div className="related-post-item">
                {this.renderPostThumbnail(item.mediaInfo)}
                <div className="related-post-item-description">
                  {item.postInfo.title}
                </div>
                <div className="related-post-item-value">
                  <div className="related-post-item-price">
                    {item.postInfo.price
                      ? "Price " +
                        item.postInfo.price +
                        " " +
                        item.postInfo.currency.toUpperCase()
                      : null}
                  </div>
                  <div className="related-post-item-time-limit">
                    {moment(item.postInfo.time_limit).format("YYYY-MM-DD")}
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    );
  }

  renderPosts() {
    const { pending_posts, recent_posts, top_rated_posts } = this.state;
    return (
      <div className="posts-container">
        <div className="post-items-title">Recent Posts</div>
        {this.renderRecentPostsRow(recent_posts)}
        <div className="post-items-title">Top Rated Posts</div>
        {this.renderTopPostsRow(top_rated_posts)}
        <div className="post-items-title">Pending Posts</div>
        {this.renderTopPostsRow(pending_posts)}
      </div>
    );
  }

  renderTripsRow(trip_plans) {
    return (
      <div className="row">
        {trip_plans.map((item, key) => {
          return (
            <div className="col-12 col-sm-3" key={key}>
              <div className="related-post-item">
                <img
                  className="related-post-item-image"
                  src={item.trip_image}
                  key={key}
                  height={200}
                ></img>
                <div className="related-post-item-description">
                  {item.title}
                </div>
                <div className="related-post-item-value">
                  <div className="related-post-item-time-limit">
                    {moment(item.from_trip_date).format("YYYY-MM-DD") +
                      " ~ " +
                      moment(item.to_trip_date).format("YYYY-MM-DD")}
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    );
  }

  renderTripPlans() {
    const { upcoming_trips, past_trips } = this.state;
    return (
      <div className="posts-container">
        <div className="post-items-title">Upcoming Trip Plan</div>
        {this.renderTripsRow(upcoming_trips)}
        <div className="post-items-title">Past Trip Plan</div>
        {this.renderTripsRow(past_trips)}
      </div>
    );
  }

  render() {
    return (
      <React.Fragment>
        <div className="row">
          <div className="col-xl-4 col-sm-6">
            {this.renderCustomerInfo()}
            {this.renderPasswordReset()}
          </div>
          <div className="col-xl-8 col-sm-6">{this.renderTabBar()}</div>
        </div>
      </React.Fragment>
    );
  }
}

CustomerDetail.propTypes = {
  getCustomerDetail: PropTypes.func.isRequired,
  getTopRatedPosts: PropTypes.func.isRequired,
  getRecentPosts: PropTypes.func.isRequired,
  getPendingPosts: PropTypes.func.isRequired,
  getTripPlans: PropTypes.func.isRequired,
  updateCustomer: PropTypes.func.isRequired,
  resetPassword: PropTypes.func.isRequired,
};

export default connect(selectors, {
  ...actions.customers,
  ...actions.posts,
  ...actions.trip_plans,
})(withRouter(CustomerDetail));



// WEBPACK FOOTER //
// ./client/react/Admin/views/CustomerDetail/index.js